import "./Invoices.scss";
import InvoiceExplorer from "./components/InvoiceExplorer";
export default function Invoices(props: any) {
  return (
    <div className="Invoices">
      <InvoiceExplorer/>
    </div>
  );
}
